import mondaySdk from 'monday-sdk-js';
const monday = mondaySdk();

export const performMondayApiRequest = (query, options) => {
  return new Promise((resolve, reject) => {
    monday
      .api(query, options)
      .then(({ data }) => resolve(data))
      .catch((err) => reject(err));
  });
};

export const getMondayInfo = (type, params) => {
  return new Promise((resolve, reject) => {
    monday
      .get(type, params)
      .then(resolve)
      .catch((err) => reject(err));
  });
};

export const listenMondayChanges = (type, callback) => {
  monday.listen(type, callback);
};

export const executeMonday = (action, options) => {
  return monday.execute(action, options);
};

export const mondayNotice = ({ type, message, timeout }) => {
  executeMonday('notice', { type, message, timeout });
};

export const openMondayModal = ({ url, urlPath, urlParams, height, width }) => {
  executeMonday('openAppFeatureModal', { url, urlPath, urlParams, height, width });
};

export const openContactSupportModal = (subject) => {
  executeMonday('openContactSupportModal', { subject });
};

export const openPricingModal = () => {
  executeMonday('openPricingModal');
};

export const getGrantedFeatures = async (features = []) => {
  try {
    const response = await executeMonday('getGrantedFeatures', { features });
    return response?.data?.features || {};
  } catch (e) {
    return {};
  }
};
